import {
  Box,
  Button,
  IconButton,
  MobileStepper,
  Typography,
} from '@mui/material';

import Question from '../../../components/shared/Question';

import { listenToQuestion } from '../../../utils/tts';

import { IQuestionCreatorComponentProps } from './types';

import {
  ArrowLeftIcon,
  CloseIcon,
  VolumeMaxIcon,
} from '../../../components/shared/CustomIcons';
import { styles } from './styles';
import React from 'react';

const QuestionCreatorComponent: React.FC<IQuestionCreatorComponentProps> = ({
  activeStep,
  stepCount,
  question,
  disableBack,
  disableSubmit,
  shouldRenderSubQuestion,
  handleBack,
  handleClose,
  setAnswer,
  handleContinue,
  setMultiTextAnswer,
}) => {
  return (
    <Box
      sx={{ bgcolor: 'solitude.main', pt: 8, px: 3, pb: 7.25 }}
      className="d-flex flex-column flex-1"
    >
      <Box sx={{ gap: 7, mb: 8 }} className="d-flex align-items-center">
        <IconButton
          aria-label="back"
          sx={{ color: 'text.primary', p: 0 }}
          onClick={handleBack}
          disabled={disableBack}
        >
          <ArrowLeftIcon sx={{ fontSize: 40 }} />
        </IconButton>
        <Box className="d-flex justify-content-center flex-1 text-uppercase">
          <Button
            sx={{ px: 3, py: 1.5, gap: 0.5 }}
            variant="contained"
            color="tertiary"
            size="small"
            startIcon={<VolumeMaxIcon />}
            onClick={() => listenToQuestion(question.question)}
          >
            Listen
          </Button>
        </Box>
        <IconButton
          aria-label="back"
          sx={{ color: 'text.primary', p: 0 }}
          onClick={handleClose}
        >
          <CloseIcon sx={{ fontSize: 40 }} />
        </IconButton>
      </Box>
      <MobileStepper
        sx={styles.mobileStepper}
        variant="progress"
        steps={stepCount}
        position="static"
        activeStep={activeStep}
        backButton={undefined}
        nextButton={undefined}
      />
      <Typography color="tertiary.main" mb={3}>
        Questions {activeStep + 1} of {stepCount}
      </Typography>
      <Question
        question={question}
        shouldRenderSubQuestion={shouldRenderSubQuestion}
        disableSubmit={disableSubmit}
        setAnswer={setAnswer}
        handleContinue={handleContinue}
        setMultiTextAnswer={setMultiTextAnswer}
      />
    </Box>
  );
};

export default QuestionCreatorComponent;
